import DashboardGenComponent from "@/components/DashboardGenComponent.tsx";
import st from "@/styles/NewCredit.module.scss";
import {useTranslation} from "react-i18next";
import SwitcherDesktop from "@/components/calculator_components/DesktopCalculatorSwitcher.tsx";
import CMS from "@/utils/cms";
import React, {useRef, useState} from "react";
import {CalculatorCreditTypes, LocalLanguage} from "@/types_and_interfaces/types";
import CalculatorCore from "@/components/calculator_components/CalculatorCore.tsx";
import {invalid_style} from "@/utils/constants";
import useAuth from "@/hooks/auth";
import {Checkbox} from "@mui/joy";
import Button from "@/ui/Button.tsx";
import DashboardClass from "@/utils/dashboard_class.ts";
import {useNavigate} from "react-router-dom";
import CalculatorLimit from "@/types_and_interfaces/calculator_limit.ts";
import useCalc from "@/hooks/calculator.ts";
import styles from "@/styles/HomeUserCalc.module.scss";
import {CircularProgress} from "@mui/material";
import clsx from "clsx";


const NewCredit = () => {

    const {t, i18n} = useTranslation()
    const genData = CMS.general_info
    const types = genData?.credit_types
    const [creditType, setCreditType] = useState<CalculatorCreditTypes>("client")
    const checkbox = useRef<any>(null)
    const agreement = CMS.langAwareFilter(genData, (i18n.language as LocalLanguage)).agreement
    const auth = useAuth()
    const navigate = useNavigate()
    const calc = useCalc()
    
    
    
    const switchCrType = (type:CalculatorCreditTypes) => {
        setCreditType(type)
    }
    
    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        
        e.preventDefault()
        const form = new FormData(e.currentTarget)
        
        if(!form.has("checkbox") && checkbox.current) {
            checkbox.current.style.outline = invalid_style
            checkbox.current.style.borderRadius = '5px'
            return
        }
        
        auth.redirectToApplyCredit(form, (calc.get_selected_type() as CalculatorLimit).category_name)
        navigate(DashboardClass.dashboard_routes.ApplyCredit)

    }
    
    return (genData && types) ? (
        <DashboardGenComponent
            responsive1
            header_type={"secondary"}
            // backFunction
            // backUrl={dc.dashboard_routes.Home}
            onBackClick={() => {
                navigate(DashboardClass.dashboard_routes.Home)
            }}
            heading={
                <div>
                    {t("apply_for_credit")}
                </div>
            }
            
            header_content={
                <div className={st.header_content}>
                    
                    <h4>
                        {t("choose_service")}
                    </h4>
                    
                    <SwitcherDesktop
                        creditType={creditType}
                        types={types}
                        switchCrType={switchCrType}
                        styles={st}
                    />
                    

                </div>
            }
            
            column_center={
                <div className={st.column_center}>
                    <form onSubmit={onSubmit}>
                        <CalculatorCore styles={st}/>
                        
                        <div className={st.form_additional_inputs}>
                            
                            <div className={st.checkbox_cont}>
                                
                                <Checkbox
                                    ref={checkbox}
                                    name={"checkbox"}
                                    defaultChecked={false}
                                    color="success"
                                    onChange={() => {
                                        if (!checkbox.current) return
                                        checkbox.current.style.outline = 'none'
                                        checkbox.current.style.borderRadius = '0'
                                    }}
                                    sx={{
                                        height: "fit-content"
                                    }}
                                />
                                
                                {(typeof agreement === "string" && agreement.length) ? (
                                    
                                    <div className={st.content} dangerouslySetInnerHTML={{__html: agreement}}/>
                                
                                ) : null}
                                
                            </div>
                            
                            <Button type={"submit"} animated className={st.submit_btn}>
                                <span>
                                    {t("apply1")}
                                </span>
                            </Button>
                            
                        </div>
                    </form>
                    
                    {(() => {
                        const types = calc.get_types();
                        return (!types || (typeof types === "object" && Object.keys(types).length === 0)) && (
                            <div className={clsx(styles.blur, styles.expanded)}>
                                {!types && (
                                    <CircularProgress color={"success"}/>
                                )}
                                
                                {(typeof types === "object" && Object.keys(types).length === 0) && (
                                    <strong>
                                        {t("calculator_nor_working")}
                                    </strong>
                                )}
                            </div>
                        );
                    })()}
                </div>
            }
        />
    ) : null
}

export default NewCredit